import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";

export async function deletePaymentCard(userId: string, paymentCardId: string): Promise<IApiResponse<any>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.deletePaymentCards(userId, paymentCardId);
    return await apiRequest<any>(endpoint, "DELETE");
}